import DateComponent from './component'
export { DateComponent }
export default DateComponent